import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getLocalAuthRedirectURL } from '@dnb/authentication';
import { log_in_medium } from '@dnb/eufemia/icons';
import { navigate } from 'gatsby';
import {MenuButton} from '@dnb/header';


const LoginButton = () => {
  return (
      <MenuButton
        text={<FormattedMessage id="dnb_header_login_button" />}
        icon={log_in_medium}
        on_click={() => navigate(getLocalAuthRedirectURL('/'))}
      />
  );
};

export default LoginButton;
